import { Facebook, TwitterX, TikTok, WhatsApp } from '@/components/ui/Icons';
import { company } from '@/data/company';
import { cn } from '@/lib/cn';

type Variant = 'navy' | 'paper';

const base =
  'group relative inline-flex h-10 w-10 items-center justify-center rounded-full transition-all duration-300 hover:-translate-y-0.5';
const styles: Record<Variant, string> = {
  navy: 'border border-paper-0/15 bg-navy-800/60 text-paper-0/85 hover:border-gold-400 hover:bg-gold-400 hover:text-navy-900',
  paper: 'border border-navy-200 bg-paper-0 text-navy-800 hover:border-gold-400 hover:bg-gold-400 hover:text-navy-900',
};

export function Socials({
  variant = 'navy',
  className,
  size = 'md',
}: {
  variant?: Variant;
  className?: string;
  size?: 'sm' | 'md';
}) {
  const items: Array<{ href: string; label: string; Icon: typeof Facebook }> = [
    { href: company.socials.facebook, label: 'Facebook', Icon: Facebook },
    { href: company.socials.twitter, label: 'X (formerly Twitter)', Icon: TwitterX },
    { href: company.socials.tiktok, label: 'TikTok', Icon: TikTok },
    {
      href: `https://wa.me/${company.whatsappTel}`,
      label: 'WhatsApp',
      Icon: WhatsApp,
    },
  ];
  const dim = size === 'sm' ? 'h-9 w-9' : 'h-10 w-10';
  return (
    <ul className={cn('flex flex-wrap items-center gap-2', className)}>
      {items.map(({ href, label, Icon }) => (
        <li key={label}>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            className={cn(base, dim, styles[variant])}
          >
            <Icon className="h-4 w-4" />
          </a>
        </li>
      ))}
    </ul>
  );
}
